import { Search, Send, Plus } from "lucide-react";
import ConfigurableButton from "../../../components/ConfigurableButton";

const Toolbar = ({
  t,
  styles,
  searchQuery,
  setSearchQuery,
  setShowRequestModal,
  setShowUploadModal,
  theme,
}) => {
  return (
    <div style={styles.card1 }>
      <div style={styles.toolbar}>
        {/* Search Input */}
        <div style={styles.searchContainer}>
          <Search style={styles.searchIcon} size={22} />
          <input
            type="text"
            placeholder={t.searchPlaceholder}
            style={styles.searchInput}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onFocus={(e) => {
              e.currentTarget.style.borderColor = "#3b82f6";
              e.currentTarget.style.boxShadow =
                theme === "dark"
                  ? "0 0 0 4px rgba(59, 130, 246, 0.2), 0 8px 24px rgba(0, 0, 0, 0.3)"
                  : "0 0 0 4px rgba(59, 130, 246, 0.15), 0 8px 24px rgba(0, 0, 0, 0.06)";
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor =
                theme === "dark"
                  ? "rgba(255, 255, 255, 0.15)"
                  : "rgba(0, 0, 0, 0.1)";
              e.currentTarget.style.boxShadow =
                theme === "dark"
                  ? "0 8px 24px rgba(0, 0, 0, 0.3)"
                  : "0 8px 24px rgba(0, 0, 0, 0.06)";
            }}
          />
        </div>

        {/* Action Buttons */}
        <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", alignItems: "center" }}>
          <ConfigurableButton
            text={t.requestDocument}
            bgColor="#f97316"
            color="#ffffff"
            width="auto"
            height="40px"
            borderRadius="8px"
            onClick={() => setShowRequestModal(true)}
            style={{ display: "inline-flex", gap: "8px" }}
          >
            <Send size={20} />
            {t.requestDocument}
          </ConfigurableButton>

          <ConfigurableButton
            text={t.upload}
            bgColor="#3b82f6"
            color="#ffffff"
            width="auto"
            height="40px"
            borderRadius="8px"
            onClick={() => setShowUploadModal(true)}
            style={{ display: "inline-flex", gap: "8px" }}
          >
            <Plus size={20} />
            {t.upload}
          </ConfigurableButton>
        </div>
      </div>
    </div>
  );
};

export default Toolbar;